/* eslint-disable */

// import {confettiExplode} from './js/confetti.js';
import { gsap } from "gsap/all";
import  SplitText  from "../js/SplitText.min.js";
import drawSVG from "../js/DrawSVGPlugin.min.js";
gsap.registerPlugin(drawSVG);

import'../js/header.js';
import'../js/links.js';
import'../js/imagesmove2.js';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    console.log('sign up page');
    // JavaScript to be fired on the home page, after the init JS
    const $successPage = document.getElementById('successPage');
    const $mainPageContent = document.getElementById('mainPageContent');
    const $submitBtn = document.querySelector('#submitBtn');
    const $successBackBtn = document.querySelector('#successBackBtn');

    // *******************************************
    // * Page INIT
    // *******************************************

    firstLoadAni();

    if ($submitBtn) {
      $submitBtn.addEventListener('mouseover', (event) => {
        submitHoverAnimate();
      }, false);
    }


    // *******************************************
    // * First Paint
    // *******************************************

    function firstLoadAni() {
      if (document.body.classList.contains('sign-up')) {

        setTimeout( () => {
          gsap.to( '#bgFadeIn' , 0.4 , {
            opacity: 1,
            ease: 'power1.in'
          })

          setTimeout( () => {
            gsap.to( '.app-wrapper' , 0.5 , {
              opacity: 1,
              ease: 'power1.in',
            })
            mainTxtAnimate();
            starsAnimate();
            arrowDraw();
            clickTxtShow();
          },350);

        },0);

      }
    }


    // *******************************************
    // * stars animation
    // *******************************************

    const starsAnimate = () => {

      const tlStarS = gsap.timeline({ repeat: -1 , repeatDelay: 0 });
      tlStarS.to( '.star-svg.st-small' , 7 , { rotate: 360, ease: "none"});
      const tlStarL = gsap.timeline({ repeat: -1 , repeatDelay: 0 });
      tlStarL.to( '.star-svg.st-big'  , 12 , { rotate: 360 , ease: "none" });

    }

    // *******************************************
    // * arrow animate - draw / hover CTA
    // *******************************************

    const arrowDraw = () => {
      gsap.fromTo( '#arrowLPath' , { drawSVG: '100% 100%' } ,  { drawSVG: '0% 100%'  , duration: 0.6 , transformOrigin:"100% 50%", delay: 1.2 } )
    }

    const clickTxtShow = () => {
      gsap.from('.click-svg' , 0.2 ,  { stagger: 0.15 , opacity: 0, delay:1 , scale: 0.5 } )
    }

    // *******************************************
    // * arrow animate - draw / hover CTA
    // *******************************************

    const submitHoverAnimate = () => {
      //console.log(document.querySelectorAll('.click-svg'));
      //console.log(document.querySelectorAll('#arrowLPath'));
      gsap.fromTo( '#arrowLPath' , { drawSVG: '100% 100%' } ,  { drawSVG: '0% 100%'  , duration: 0.6 , transformOrigin:"100% 50%", delay: 0 } )
      gsap.from('.click-svg' , 0.2 ,  { stagger: 0.15 , opacity: 0, delay:0 , scale: 0.5 } )
    }

    // *******************************************
    // * Main text animation
    // *******************************************

    const aniConf = {
      stagger: 0.04, // 0.05
      opacity: 0 ,
      scale: 0,
      transformOriginIn: "0% 50% -50",
      transformOriginOut: "50% 50% -50",
      rotationXIn: -180,
      rotationXOut: 180,
      posYin: 80,
      posYout: -80,
      ease: 'power4.inOut',
      // inTime: 0.9,
      // outTime: 0.9,
      inTime: 0.8,
      outTime: 0.8,
      // outDelay: '-=1.1',
      // nextInDelay: '+=2.5',
      outDelay: '-=1',
      nextInDelay: '+=1',
      initialDelay: 0,
    };


    const adjustAniConfToScreen = () => {
      if (window.innerWidth < 1024){
        aniConf.posYin = 20;
        aniConf.posYout = -40;
      }
      if(window.innerWidth < 550){
        aniConf.posYin = -30;
        aniConf.posYout = 10;
      }
    }

    adjustAniConfToScreen();
    window.addEventListener("resize", adjustAniConfToScreen);

    const mainTxtAnimate = () => {

      const aniTexts = document.getElementsByClassName('main-txt-ani');

      if(!aniTexts.length) return;

      const aniTextsSplitted = [];

      for (var i = 0; i < aniTexts.length; i++) {
        gsap.set(aniTexts[i], {perspective: 400});
        aniTextsSplitted[i] =  new SplitText( aniTexts[i] , {type: "words, lines, chars"});
      }

      gsap.from( aniTextsSplitted[0].chars, aniConf.inTime, { stagger: { each: aniConf.stagger }, opacity:aniConf.opacity, y:aniConf.posYin, scale:aniConf.scale, ease: aniConf.ease, rotationX: aniConf.rotationXIn, transformOrigin:aniConf.transformOriginIn , delay: aniConf.initialDelay} )

      const tl = gsap.timeline({repeat: -1, repeatDelay: 0, delay: aniConf.initialDelay + aniConf.inTime })
      .to( aniTextsSplitted[0].chars, aniConf.outTime, { stagger: { each: aniConf.stagger }, opacity:aniConf.opacity, y:aniConf.posYout, scale:aniConf.scale, ease: aniConf.ease, rotationX: aniConf.rotationXOut, transformOrigin:aniConf.transformOriginOut } , aniConf.nextInDelay )
      .from( aniTextsSplitted[1].chars, aniConf.inTime, { stagger: { each: aniConf.stagger }, opacity:aniConf.opacity, y:aniConf.posYin, scale:aniConf.scale, ease: aniConf.ease, rotationX: aniConf.rotationXIn, transformOrigin:aniConf.transformOriginIn } , aniConf.outDelay )
      .to( aniTextsSplitted[1].chars, aniConf.outTime, { stagger: { each: aniConf.stagger }, opacity:aniConf.opacity, y:aniConf.posYout, scale:aniConf.scale, ease: aniConf.ease, rotationX: aniConf.rotationXOut, transformOrigin:aniConf.transformOriginOut } , aniConf.nextInDelay )
      .from( aniTextsSplitted[2].chars, aniConf.inTime, { stagger: { each: aniConf.stagger }, opacity:aniConf.opacity, y:aniConf.posYin, scale:aniConf.scale, ease: aniConf.ease, rotationX: aniConf.rotationXIn, transformOrigin:aniConf.transformOriginIn  } , aniConf.outDelay )
      .to( aniTextsSplitted[2].chars, aniConf.outTime, { stagger: { each: aniConf.stagger }, opacity:aniConf.opacity, y:aniConf.posYout, scale:aniConf.scale, ease: aniConf.ease, rotationX: aniConf.rotationXOut, transformOrigin:aniConf.transformOriginOut } , aniConf.nextInDelay )
      .fromTo( aniTextsSplitted[0].chars, { opacity: aniConf.opacity, y:aniConf.posYin , scale:aniConf.scale, ease: aniConf.ease, rotationX: aniConf.rotationXIn, transformOrigin:aniConf.transformOriginIn }, { duration: aniConf.inTime, stagger: { each: aniConf.stagger }, opacity:1, y:0, scale:1, ease: aniConf.ease, rotationX: 0, transformOrigin: aniConf.transformOriginIn }, aniConf.outDelay )

    }


    // *******************************************
    // * Succes page
    // *******************************************

    // Edited - for thank you page forward
    const successPageAnimate = () => {
      gsap.to( $mainPageContent , 0.3,  {
        opacity: 0,
        ease: "power4.out",
      })
      gsap.to( '#bgFadeIn' , 0.5, {
        opacity: 0,
        ease: 'power1.in'
      })
      gsap.to( '.app-wrapper' , 0.5, {
        opacity: 0,
        ease: 'power1.in',
        onComplete: () => {
          window.location.pathname = '/thank-you';
        },
      })
    }

    const backToMainPage = () => {
      gsap.to($successPage , 0.5,  {
        opacity: 0,
        ease: "power2",
        zIndex: -1,
      })
      gsap.to($mainPageContent , 0.5,  {
        opacity: 1,
        ease: "power2",
        delay: 0.2,
      })
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    //MAILCHIMPdd
    $('.mc-form').on('submit', function(e) {
      //console.log('submit click');
      e.preventDefault();
      $('.mc-form .message').html('').removeClass('error').removeClass('success');

      const email = $(this).find('#mc-email').val();
      const form = $( this );
      const campaign2 = $(this).data('campaign');
      const campaign = (urlParams.get('utm_campaign') !== null) ? urlParams.get('utm_campaign') : campaign2;
      const source2 = $(this).data('source');
      const source = (urlParams.get('utm_source') !== null) ? urlParams.get('utm_source') : source2;

      //console.log(source);

      var data = {
        action: 'exsite_mailchimp',
        email: email,
        source: source,
        campaign: campaign,
        form: $( this ).serialize(),
      };

      var button_text = form.find('button').html();
      form.find('button').html('Submitting...').prop('disabled', true);

      // $.post(ajaxurl, data, function(response) {
      //   response = $.parseJSON(response);
      //   console.log(response);
      //   form.find('button').html(button_text).prop('disabled', false);

      //   if(response.result == "error") {
      //     form.parent().find('#message').addClass('error').html(response.msg);
      //     return false;
      //   }

      //   if(response.result == "subscribed") {
      //     form.parent().find('#message').html(response.msg);
      //     return false;
      //   }

      //   if(response.result == "timeout") {
      //     successPageAnimate();
      //   }

      //   form.parent().find('#message').addClass('success').html(response.msg);

      //   //fbq('track', 'SubmitApplication');

      //   // snaptr('init', 'df16150d-6ef6-4a1e-a051-cc6345ae3468', {
      //   // 'user_email': form[0][0].value
      //   // });

      //   // snaptr('track', 'SIGN_UP');

      //   successPageAnimate();

      // });

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: data,
        timeout: 10000,
        success: function(response) {
          response = $.parseJSON(response);
          console.log('h',response);

          if(response.result == "success") {
            fbq('track', 'SubmitApplication', {});
            // fbq('trackCustom', 'MailChimpForm', {status: response.result});
            // fbq('track', 'SubmitApplication', {status: response.result});

            form.parent().find('#message').html(response.msg);
            form.parent().find('#message').addClass('active');
            successPageAnimate();
          }

          if(response.result == "error") {
            form.parent().find('#message').addClass('error').html(response.msg);
            form.parent().find('#message').addClass('active');
            form.find('button').html(button_text).prop('disabled', false);
          return false;
          }

          if(response.result == "subscribed" || response.result == "resubscribed") {

            // fbq('track', 'SubmitApplication', {status: response.result});
            fbq('track', 'SubmitApplication', {});
            // fbq('trackCustom', 'MailChimpForm', {status: response.result});

            form.parent().find('#message').html(response.msg);
            form.parent().find('#message').addClass('active');
            form.find('button').html(button_text).prop('disabled', false);
            return false;
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          if(textStatus==="timeout") {
            successPageAnimate();
          }
        }
      });

      return false;

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/sign-up.js